import { Outlet } from 'react-router-dom'

import Footer from 'components/Footer'

function Layout() {
	return (
		<>
			<main data-bs-spy="scroll" data-bs-target="#main-nav" data-bs-offset="0">
				<Outlet />
			</main>
			<Footer />
		</>
	)
}

export default Layout
